export default "__VITE_ASSET__DLebaUqR__"